import * as yup from 'yup';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import { useLocale } from '@gov-nx/core/service';
import type { ServiceCode } from '@gov-nx/module/service';
import { RadioBooleanOption } from '@gov-nx/ui/types';
import type { FormDataStep2a } from './context.types';
import type { IFormStep2a } from './form.types';

interface FormStep2Props {
	code: ServiceCode;
	isProcessing: boolean;
	embassyOfficesOptions: { value: string; label: string }[];
}

export const FormStep2a = ({
	code,
	embassyOfficesOptions,
	isProcessing,
}: FormStep2Props): IFormStep2a => {
	const { t } = useLocale(code);

	const formSchema = yup
		.object({
			livesAbroad: yup.string().oneOf(Object.values(RadioBooleanOption)),
			onSpecialList: yup.string().oneOf(Object.values(RadioBooleanOption)),

			embassyCode: yup.string(),
		})
		.required();

	const formMethods = useGovForm<FormDataStep2a>({
		formSchema,
		defaultValues: {
			livesAbroad: RadioBooleanOption.no,
			onSpecialList: RadioBooleanOption.no,
			embassyCode: '',
		},
	});

	return {
		fields: {
			embassy: {
				label: { children: t('formular.pole.misto-zastupitelskehu-uradu') },
				field: {
					name: 'embassyCode',
					isDisabled: isProcessing,
					options: [
						{
							value: '',
							label: t('formular.pole.misto-zastupitelskehu-uradu-zvolte'),
							isDisabled: true,
						},
						...embassyOfficesOptions,
					],
				},
			},
		},
		formDefinition: getFormDefinition({ formMethods, formSchema }),
	};
};
